import React, { memo } from "react";
import { startOfDay, endOfDay, subDays } from "date-fns";
import { CustomProvider, DateRangePicker } from "rsuite";
import { useTranslation } from "react-i18next";
import "./dateRangePicker.css";

interface DateRangePickerInterface {
  setFilteredData: any
}

function DateRangePickerComponent({setFilteredData}: DateRangePickerInterface) {
  const { t } = useTranslation();
  const themeValue = localStorage.getItem("theme") || "dark";
  const placeholder = t("INCIDENTS_PAGE.START_DATE_END_DATE");

  const handleDateRangeChange = (value) => {
    if (value && value.length === 2) {
      const startDate = new Date(value[0]);
      const endDate = new Date(value[1]);

      setFilteredData({filter: {"start": startDate, "end": endDate}});
    }
  };

  const handleDateRangeClean = () => {
    setFilteredData({filter: {"start": "", "end": ""}});
  }

  return (
    <CustomProvider theme={themeValue === "dark" ? "dark" : "light"}>
      <DateRangePicker
        size={"md"}
        placeholder={placeholder}
        showOneCalendar
        format="yyyy-MMM-dd"
        preventOverflow={false}
        style={{ width: 300 }}
        onChange={handleDateRangeChange}
        onClean={handleDateRangeClean}
        ranges={[
          {
            label: t("INCIDENTS_PAGE.LAST_SEVEN_DAYS"),
            value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())],
          },
          {
            label: t("INCIDENTS_PAGE.LAST_THIRTY_DAYS"),
            value: [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())],
          },
          {
            label: t("INCIDENTS_PAGE.LAST_SIXTY_DAYS"),
            value: [startOfDay(subDays(new Date(), 60)), endOfDay(new Date())],
          },
          {
            label: t("INCIDENTS_PAGE.LAST_NINTY_DAYS"),
            value: [startOfDay(subDays(new Date(), 90)), endOfDay(new Date())],
          },
        ]}
      />
    </CustomProvider>
  );
}

export default memo(DateRangePickerComponent);
